 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","contact":"contact","global":"global","inactive":"inactive","no-layout~pricing":"no-layout~pricing","pricing":"pricing","npm.element-ui":"npm.element-ui","npm.babel":"npm.babel","no-layout":"no-layout","npm.resize-observer-polyfill":"npm.resize-observer-polyfill","npm.core-js":"npm.core-js","auth":"auth","billing":"billing","onboarding":"onboarding","npm.normalize-wheel":"npm.normalize-wheel","agency":"agency","dashboard":"dashboard","deals":"deals","my-portals":"my-portals","notifications":"notifications","prospect":"prospect","prospect-lists":"prospect-lists","refer":"refer","npm.swiper":"npm.swiper","social":"social","npm.tinymce":"npm.tinymce","settings":"settings","npm.sweetalert2":"npm.sweetalert2","support":"support","training":"training","prospect-companies-view":"prospect-companies-view","prospect-people-view":"prospect-people-view","landing":"landing","npm.d3-selection":"npm.d3-selection","npm.d3-array":"npm.d3-array","npm.dropzone":"npm.dropzone","npm.webpack":"npm.webpack","npm.datamaps":"npm.datamaps"}[chunkId]||chunkId) + "." + {"about":"548260ea","contact":"4e84cd03","global":"c0e3f384","inactive":"b916f867","no-layout~pricing":"fc9572ca","pricing":"ee9377e4","npm.element-ui":"095c5a75","npm.babel":"66083f98","no-layout":"f31ced16","npm.resize-observer-polyfill":"67a43d49","npm.core-js":"9707d685","auth":"90b87ca4","billing":"d04b5744","onboarding":"ed1d09a0","npm.normalize-wheel":"b9f49dea","agency":"ee7ec285","dashboard":"efb57990","deals":"ad0c9e5d","my-portals":"7363cef4","notifications":"1759cfa1","prospect":"9b04ad34","prospect-lists":"c6d2404b","refer":"903317c0","npm.swiper":"9d0fead6","social":"2fc0a481","npm.tinymce":"6d17b32a","settings":"ccd440e2","npm.sweetalert2":"8de77308","support":"24aa38c0","training":"8ecb0d37","prospect-companies-view":"a027b31a","prospect-people-view":"c9d5ac68","landing":"9ae2e9e8","npm.d3-selection":"786c01c5","npm.d3-array":"f98b6208","chunk-ab7e0cd8":"a1be9733","npm.dropzone":"6f5e07c3","npm.webpack":"bbefc504","npm.datamaps":"73c75f96"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"pricing":1,"npm.element-ui":1,"no-layout":1,"auth":1,"billing":1,"onboarding":1,"agency":1,"dashboard":1,"deals":1,"my-portals":1,"notifications":1,"prospect":1,"prospect-lists":1,"refer":1,"social":1,"settings":1,"support":1,"training":1,"prospect-companies-view":1,"prospect-people-view":1,"landing":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","contact":"contact","global":"global","inactive":"inactive","no-layout~pricing":"no-layout~pricing","pricing":"pricing","npm.element-ui":"npm.element-ui","npm.babel":"npm.babel","no-layout":"no-layout","npm.resize-observer-polyfill":"npm.resize-observer-polyfill","npm.core-js":"npm.core-js","auth":"auth","billing":"billing","onboarding":"onboarding","npm.normalize-wheel":"npm.normalize-wheel","agency":"agency","dashboard":"dashboard","deals":"deals","my-portals":"my-portals","notifications":"notifications","prospect":"prospect","prospect-lists":"prospect-lists","refer":"refer","npm.swiper":"npm.swiper","social":"social","npm.tinymce":"npm.tinymce","settings":"settings","npm.sweetalert2":"npm.sweetalert2","support":"support","training":"training","prospect-companies-view":"prospect-companies-view","prospect-people-view":"prospect-people-view","landing":"landing","npm.d3-selection":"npm.d3-selection","npm.d3-array":"npm.d3-array","npm.dropzone":"npm.dropzone","npm.webpack":"npm.webpack","npm.datamaps":"npm.datamaps"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","contact":"31d6cfe0","global":"31d6cfe0","inactive":"31d6cfe0","no-layout~pricing":"31d6cfe0","pricing":"04306d2c","npm.element-ui":"cdfed08a","npm.babel":"31d6cfe0","no-layout":"30df2f68","npm.resize-observer-polyfill":"31d6cfe0","npm.core-js":"31d6cfe0","auth":"42bda83b","billing":"ba91033a","onboarding":"844ccb9e","npm.normalize-wheel":"31d6cfe0","agency":"7d6ae066","dashboard":"0dd44ea5","deals":"71ddbacd","my-portals":"7d6ae066","notifications":"7d6ae066","prospect":"6e58ba56","prospect-lists":"17c3f4fe","refer":"7d6ae066","npm.swiper":"31d6cfe0","social":"59ba0aae","npm.tinymce":"31d6cfe0","settings":"b74f3eb0","npm.sweetalert2":"31d6cfe0","support":"2d3c567b","training":"ee9f6c52","prospect-companies-view":"00132401","prospect-people-view":"d4db253d","landing":"7ae7f412","npm.d3-selection":"31d6cfe0","npm.d3-array":"31d6cfe0","chunk-ab7e0cd8":"31d6cfe0","npm.dropzone":"31d6cfe0","npm.webpack":"31d6cfe0","npm.datamaps":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/vue_argon_pro/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "56d7");
